import { Component, OnInit, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";
import { ViewChild } from "@angular/core";

import { UserService } from "../../../shared/services/user.service";
import { DataService_idprintlockout } from "./shared/data.service";
import { wsIDPrintLockoutInfo } from "./shared/wsIDPrintLockoutInfo";
import { wsIDPrinterLockoutUpdateParm } from "./shared/wsIDPrinterLockoutUpdateParm";
import { wsIDPrinterLockoutItems } from "./shared/wsIDPrinterLockoutUpdateParm";

@Component({
	selector: "app-root",
	templateUrl: "./idprintlockout.component.html",
	styleUrls: ["./idprintlockout.component.css"],
})
export class IDPrintLockoutComponent implements OnInit, OnDestroy 
{
	@ViewChild("mydt") mydt: Table;

	@ViewChild("filterActive", { static: false }) 
	public filterActive: Dropdown;

	@ViewChild("filterIsInDepotMode", { static: false }) 
	public filterIsInDepotMode: Dropdown;

	@ViewChild("filterDistrictLock", { static: false })
	public filterDistrictLock: Dropdown;

	@ViewChild("filterFacilityLock", { static: false })
	public filterFacilityLock: Dropdown;	

	constructor(private dataService: DataService_idprintlockout, private userService: UserService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	Depot Printers List
	public lstIDPrinterLockout: wsIDPrintLockoutInfo[] = [];

	//	Alert List
	public SelectedPrinter: wsIDPrintLockoutInfo;

	//	Filters
	public lstActive: any = [];
	public lstDepotMode: any = [];
	public lstDistrictLock: any = [];
	public lstFacilityLock: any = [];

	//	Alert Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() 
	{
		this.user = this.userService.getCurrentUser();

		this.isBusy = true;
		this.dataService.IDPrinterLockoutSelectList().subscribe((data) => this.IDPrinterLockoutSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrinterLockoutSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrinterLockoutSelectList_Complete(data: any) 
	{
		this.SelectedPrinter = null;
		this.lstIDPrinterLockout = data;
		
		//
		//	Set Filter Lists
		//
		this.lstActive = Array.from(new Set(this.lstIDPrinterLockout.map((item: any) => item.IDPrinterID_Active)));
		this.lstDepotMode = Array.from(new Set(this.lstIDPrinterLockout.map((item: any) => item.KeyValue_IsInDepotMode)));
		this.lstDistrictLock = Array.from(new Set(this.lstIDPrinterLockout.map((item: any) => item.KeyValue_IsDistrictLockOut)));
		this.lstFacilityLock = Array.from(new Set(this.lstIDPrinterLockout.map((item: any) => item.KeyValue_IsFacilityLockOut)));

		//
		//	Set Filter Defaults
		//
		this.onSetFilterDefaults();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "ScanStation", order: 1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() 
	{
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() 
	{
		this.ErrorMessage = "";

		this.isBusy = true;
		this.dataService.IDPrinterLockoutSelectList().subscribe((data) => this.IDPrinterLockoutSelectList_Complete(data));	
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleDepotMode
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleDepotMode() 
	{
		this.ErrorMessage = "";

		if (this.SelectedPrinter == null) {
			this.ErrorMessage = "Please select a printer.";
			return;
		}		

		if (this.SelectedPrinter.KeyValue_IsInDepotMode == "True")
		{
			this.SelectedPrinter.KeyValue_IsInDepotMode = "False";
		}
		else
		{
			this.SelectedPrinter.KeyValue_IsInDepotMode = "True";
		}
		
		this.SelectedPrinter.IsSelected = true
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleDistrictLockOut
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleDistrictLockOut() 
	{
		this.ErrorMessage = "";

		if (this.SelectedPrinter == null) {
			this.ErrorMessage = "Please select a printer.";
			return;
		}	
		
		if (this.SelectedPrinter.KeyValue_IsDistrictLockOut == "True")
		{
			this.SelectedPrinter.KeyValue_IsDistrictLockOut = "False";
		}
		else
		{
			this.SelectedPrinter.KeyValue_IsDistrictLockOut = "True";
		}		

		this.SelectedPrinter.IsSelected = true
	}
	
	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleFacilityLockOut
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleFacilityLockOut() 
	{
		this.ErrorMessage = "";

		if (this.SelectedPrinter == null) {
			this.ErrorMessage = "Please select a printer.";
			return;
		}	
		
		if (this.SelectedPrinter.KeyValue_IsFacilityLockOut == "True")
		{
			this.SelectedPrinter.KeyValue_IsFacilityLockOut = "False";
		}
		else
		{
			this.SelectedPrinter.KeyValue_IsFacilityLockOut = "True";
		}		
		
		this.SelectedPrinter.IsSelected = true
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetFilterDefaults
	//
	//-----------------------------------------------------------------------------------------------------
	onSetFilterDefaults() 
	{
		this.mydt.filters.IDPrinterID_Active["value"] = null; 			// Default To 'Any'
		this.mydt.filters.KeyValue_IsInDepotMode["value"] = null; 		// Default To 'Any'
		this.mydt.filters.KeyValue_IsDistrictLockOut["value"] = null; 	// Default To 'Any'
		this.mydt.filters.KeyValue_IsFacilityLockOut["value"] = null; 	// Default To 'Any'		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) 
	{
		//
		//	Need to set SelectedPrinter here. We don't unselect when selected.
		//
		this.SelectedPrinter = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}


	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowDblClick
	//
	//-----------------------------------------------------------------------------------------------------
	onRowDblClick(item: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() 
	{
		let SelectedItems: wsIDPrinterLockoutUpdateParm = { ItemList: [] };

		this.lstIDPrinterLockout.forEach((element) => {
			if (element.IsSelected == true) 
			{
				let r: wsIDPrinterLockoutItems = 
				{
					PreferenceID_IsInDepotMode: element.PreferenceID_IsInDepotMode,
					KeyValue_IsInDepotMode: element.KeyValue_IsInDepotMode,
					PreferenceID_IsDistrictLockOut: element.PreferenceID_IsDistrictLockOut,
					KeyValue_IsDistrictLockOut: element.KeyValue_IsDistrictLockOut,
					PreferenceID_IsFacilityLockOut: element.PreferenceID_IsFacilityLockOut,
					KeyValue_IsFacilityLockOut: element.KeyValue_IsFacilityLockOut,
					IsSelected: true
				};

				SelectedItems.ItemList.push(r);
			}
		});	
		
		if (SelectedItems.ItemList.length > 0) 
		{
			this.isBusy = true;
			this.dataService.IDPrinterLockoutUpdate(SelectedItems).subscribe((data) => this.onUpdate_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate_Complete(data: any) 
	{
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------

}
